
export default {
  namespaced: true,
  state: {
    count: 0
  },
  actions: {
    async list ({ dispatch, state }, params) {
      var id = params.id
      return dispatch('request', { url: `conventional-tracking-requests/${id}/devices`, method: 'get' }, { root: true })
        .then(response => {
          return response.data
        })
        .catch(error => { throw error })
    },
    async save ({ dispatch, state }, data) {
      let id = data.id
      return dispatch('request', { url: `conventional-tracking-requests/${id}/devices`, method: 'post', data: data.data }, { root: true })
        .then(response => {
          return response.data
        })
        .catch(error => { throw error })
    },
    async delete ({ dispatch, state }, params) {
      let id = params.id
      let idDevice = params.idDevice
      params = undefined
      return dispatch('request', { url: `conventional-tracking-requests/${id}/devices/${idDevice}`, method: 'delete' }, { root: true })
        .then(response => {
          return response.data
        })
        .catch(error => { throw error })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/device.js